import { createSelector } from '@reduxjs/toolkit';
import { selectTravelTime } from 'shared/selectors/jsonQuery';
import { plural } from '@cian/utils';

export const selectTravelTimeFilter = createSelector(selectTravelTime, value => ({
  label: 'Не более',
  postfix: (value && plural(value, ['минуты', 'минут', 'минут'])) || 'минут',
  value: value ? String(value) : '',
}));
